import { Component, Input } from '@angular/core';
import { LoadingController, ModalController } from '@ionic/angular';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { CarritoService } from 'src/app/services/carrito.service';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { finalize } from 'rxjs/operators';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-modal-talla-cantidad',
  templateUrl: './modal-talla-cantidad.component.html',
  styleUrls: ['./modal-talla-cantidad.component.scss']
})
export class ModalTallaCantidadComponent {
  @Input() tallas: string[] = [];

  @Input() colorSeleccionado: string = ''; // ← nuevo input
  @Input() product: any ;

  form: FormGroup;

  constructor(
    private modalCtrl: ModalController,
    private fb: FormBuilder,
    private carrito : CarritoService,
    private loadingCtrl: LoadingController,
    private storage: AngularFireStorage,
  ) {
    this.form = this.fb.group({
      combinaciones: this.fb.array([this.crearCombinacion()]),
      especificaciones: [''],
      etiqueta: ['prenda personalizada'], // ← etiqueta fija
      color: [''] // ← se llena en ngOnInit
    });
  }

  ngOnInit() {
    console.log(this.colorSeleccionado);

    console.log('descripcion recibido:',  this.product);
  }

  get combinaciones(): FormArray {
    return this.form.get('combinaciones') as FormArray;
  }

  crearCombinacion(): FormGroup {
    return this.fb.group({
      talla: [null, Validators.required],
      cantidad: [1, [Validators.required, Validators.min(1)]]
    });
  }

  agregarCombinacion() {
    this.combinaciones.push(this.crearCombinacion());
  }

  eliminarCombinacion(index: number) {
    this.combinaciones.removeAt(index);
  }

  cerrar() {
    this.modalCtrl.dismiss();
  }

  async confirmar() {
    if (this.form.invalid) return;

    const loading = await this.loadingCtrl.create({
      message: 'Subiendo imágenes...',
      spinner: 'crescent'
    });

    await loading.present();

    try {
      // 1. Obtener datos del localStorage
      const data = JSON.parse(localStorage.getItem('camisetaDiseñada') || '{}');
      const estampados: string[] = Array.isArray(data.estampados) ? data.estampados : [];
      const vistasObj = data.vistas;
      const vistas: string[] = vistasObj && typeof vistasObj === 'object'
        ? Object.values(vistasObj)
        : [];
      // 2. Función auxiliar para subir imágenes base64
      const subirImagenes = async (imagenes: string[], folder: string): Promise<string[]> => {
        const uploadPromises = imagenes.map(async (base64: string) => {
          const path = `${folder}/${uuidv4()}.png`;
          const task = this.storage.ref(path).putString(base64, 'data_url');
          await task;
          return this.storage.ref(path).getDownloadURL().toPromise();
        });
        return Promise.all(uploadPromises);
      };

      // 3. Subir estampados y vistas
      const [urlsEstampados, urlsVistas] = await Promise.all([
        subirImagenes(estampados, 'estampados'),
        subirImagenes(vistas, 'vistas')
      ]);

      // 4. Preparar objeto final del producto
      const productoConImagenes = {
        ...this.product,
        productoPersonalizado : true,
        estampadosUrl: urlsEstampados,
        vistasUrl: urlsVistas,
        fechaCreacion: data.fecha,
        etiqueta: this.form.value.etiqueta,
        color: this.colorSeleccionado,
        especificaciones: this.form.value.especificaciones
      };

      // 5. Preparar combinaciones (pueden ser múltiples)
      const combinaciones = this.form.value.combinaciones.map((c: any) => ({
        cantidad: c.cantidad,
        color: this.colorSeleccionado,
        talla: c.talla
      }));

      // 6. Añadir al carrito
      this.carrito.addProduct(productoConImagenes, combinaciones);

      await loading.dismiss();

      // 7. Cerrar modal
      this.modalCtrl.dismiss({ success: true });

    } catch (error) {
      console.error('Error al confirmar:', error);
      await loading.dismiss();
      // Podrías lanzar un toast aquí si lo deseas
    }
  }


}
